module.exports = __webpack_public_path__ + "img/tips-rest.a9891c83.svg";